import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { ArabicText } from "@/components/ArabicText";
import { Clock } from "lucide-react";
import { t } from "@/i18n";

const LEVELS = ["A1", "A2", "B1", "B2", "C1", "C2"];

export default function Reading() {
  const [level, setLevel] = useState("A1");
  const [items, setItems] = useState([]);
  const nav = useNavigate();

  useEffect(() => { api.get(`/content/reading?level=${level}`).then((r) => setItems(r.data)); }, [level]);

  return (
    <div>
      <div className="flex items-center justify-between flex-wrap gap-3 mb-2">
        <h1 className="font-head text-3xl font-bold">{t("reading.lecture_graduee")}</h1>
        <button onClick={() => nav("/learn/grammar")} className="text-sm text-primary hover:underline" data-testid="reading-basics">{t("reading.revoir_les_bases_de_la_construction")}</button>
      </div>
      <p className="text-muted-foreground mb-6">{t("reading.des_textes_au_vocabulaire_strictement_progressif")}</p>

      <div className="flex gap-2 mb-6 overflow-x-auto">
        {LEVELS.map((l) => (
          <button key={l} data-testid={`reading-level-${l}`} onClick={() => setLevel(l)}
            className={`px-4 py-2 rounded-xl text-sm font-medium border transition ${level === l ? "bg-primary text-primary-foreground border-primary" : "hover:bg-secondary"}`}>{l}</button>
        ))}
      </div>

      {items.length === 0 ? (
        <div className="text-muted-foreground rounded-2xl border bg-card p-8 text-center">{t("reading.aucun_texte_pour_ce_niveau_bientot")}</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((r) => (
            <button key={r.id} data-testid={`reading-card-${r.id}`} onClick={() => nav(`/practice/reading/${r.id}`)}
              className="card-hover rounded-2xl border bg-card overflow-hidden text-left">
              <div className="h-28 bg-gradient-to-br from-skill-reading/30 to-skill-reading/5 flex items-center justify-center">
                <ArabicText size="text-4xl" noZoom className="text-skill-reading">{r.title_ar}</ArabicText>
              </div>
              <div className="p-4">
                <div className="font-semibold">{r.title_fr}</div>
                <div className="text-xs text-muted-foreground mb-2">{r.translit}</div>
                <p className="text-sm text-muted-foreground mb-2">{r.desc}</p>
                <div className="flex items-center gap-1 text-xs text-muted-foreground"><Clock size={12} />{r.minutes} {t("reading.min")} {r.n_sentences} phrases</div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
